import { render, staticRenderFns } from "./FrzCtnPalletSampling.vue?vue&type=template&id=5d2cbf55&v-slot%3Ano-data=true"
import script from "./FrzCtnPalletSampling.vue?vue&type=script&lang=js"
export * from "./FrzCtnPalletSampling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports